import { type ReactNode } from "react";

import { Button } from "@/components/Button/Button";
import { DrawerContent } from "@/components/Drawer";
import { Drawer } from "@/components/Drawer/Drawer";

type Props = {
  title: ReactNode;
  description?: ReactNode;
  closeLabel: ReactNode;
  confirmLabel: ReactNode;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function ConfirmDrawer({
  title,
  description,
  closeLabel,
  confirmLabel,
  open,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Drawer open={open} onClose={onClose} disableRestoreFocus>
      <DrawerContent>
        <div className="flex h-full w-full flex-col items-center">
          <h5 className="mt-2 mb-3 text-base leading-6 font-medium text-text-title">
            {title}
          </h5>
          {description ? (
            <span className="text-sm font-normal text-text-primary">
              {description}
            </span>
          ) : null}
          <div className="mt-10 flex w-full flex-col gap-2">
            <Button onClick={onConfirm} variant="contained" color="error">
              {confirmLabel}
            </Button>
            <Button onClick={onClose} variant="text">
              {closeLabel}
            </Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
